import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { LastMinuteRuleDetails } from '../../../common/types/rates.types';
import LastMinuteForm from './LastMinuteForm';
import {
  deleteSeasonRateRuleAsync,
  getSeasonRateLastMinuteRuleAsync,
  selectLastMinuteRuleDetails,
  selectLastMinuteRuleDetailsLoadingStatus,
  updateSeasonRateLastMinuteRuleAsync,
} from '../seasonRateRulesSlice';

function SeasonRateLastMinute({
  seasonRateId,
  hasWriteAccess,
}: {
  seasonRateId: string;
  hasWriteAccess: boolean;
}) {
  const dispatch = useAppDispatch();
  const lastMinuteRuleDetails = useAppSelector(selectLastMinuteRuleDetails);
  const lastMinuteStatus = useAppSelector(
    selectLastMinuteRuleDetailsLoadingStatus,
  );

  const initialData: LastMinuteRuleDetails = {
    seasonRateId,
    daysUntilStart: null,
    priceChange: {
      priceChangeType: 0,
      percent: 0,
      difference: 0,
    },
    isActive: true,
    isCopyable: true,
  };

  const [data, setData] = useState(initialData);
  const [submitted, setSubmitted] = useState(false);
  const [deleted, setDeleted] = useState(false);

  useEffect(() => {
    dispatch(getSeasonRateLastMinuteRuleAsync(seasonRateId));
  }, [seasonRateId, dispatch]);

  useEffect(() => {
    if (lastMinuteRuleDetails && lastMinuteRuleDetails.id) {
      setData(lastMinuteRuleDetails);
    } else {
      setData(initialData);
    }
  }, [lastMinuteRuleDetails]);

  const handleInputChange = event => {
    const path = event.target.name.split('.');
    const finalProp = path.pop();
    const newData = { ...data };
    let pointer = newData;
    path.forEach(el => {
      pointer[el] = { ...pointer[el] };
      pointer = pointer[el];
    });
    pointer[finalProp] =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    setData(newData);
  };

  const handleSelectChange = (selectedOption, name) => {
    const path = name.split('.');
    const finalProp = path.pop();
    const newData = { ...data };
    let pointer = newData;
    path.forEach(el => {
      pointer[el] = { ...pointer[el] };
      pointer = pointer[el];
    });
    pointer[finalProp] = selectedOption.value;
    setData(newData);
  };

  const onSubmit = () => {
    dispatch(updateSeasonRateLastMinuteRuleAsync(data));
    setSubmitted(true);
  };

  const onDelete = () => {
    if (window.confirm('Haluatko varmasti poistaa säännön?')) {
      dispatch(deleteSeasonRateRuleAsync(data.id));
      setSubmitted(false);
      setData(initialData);
      setDeleted(true);
    }
  };

  return (
    <LastMinuteForm
      loadingStatus={lastMinuteStatus}
      handleInputChange={handleInputChange}
      handleSelectChange={handleSelectChange}
      onSubmit={onSubmit}
      onDelete={onDelete}
      submitted={submitted}
      deleted={deleted}
      data={data}
      hasWriteAccess={hasWriteAccess}
    />
  );
}

export default SeasonRateLastMinute;
